// filepath: /home/yosef-benny-widyokarsono/kominfo/emas/app/javascript/controllers/custom_file_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "input", "label" ]
  static values = { defaultText: String }

  connect() {
    // console.log("CustomFile connected"); // Uncomment for debugging
  }

  updateLabel() {
    // console.log("updateLabel triggered"); // Uncomment for debugging
    const files = this.inputTarget.files;
    // console.log("Files:", files); // Uncomment for debugging

    if (files.length === 0) {
      this.labelTarget.textContent = this.data.get("defaultText") || "No file selected"
    } else if (files.length === 1) {
      this.labelTarget.textContent = files[0].name
    } else {
      this.labelTarget.textContent = Array.from(files).map(f => f.name).join(", ")
    }
  }
}